import { initAccountPage } from './account/controller.js';

export { initAccountPage };

initAccountPage();
